import React, { Component } from 'react';
import { connect } from 'react-redux';
import commonUtil from '../../utils/commonUtil';

class DownloadPdfHeader extends Component {
  constructor(props) {
    super(props);
    this.getBrandLogoPath = this.getBrandLogoPath.bind(this);
    this.brandLogo = '';
  }

  getBrandLogoPath = () => {
    const brand = commonUtil.getBrand();
    let path = '';
    switch (brand) {
      case 'LP':
        path = commonUtil.getAssetURL() + '/images/liverpool_logo.gif';
        break;
      case 'PB':
        path = commonUtil.getAssetURL() + '/images/logos/logo-pb.png';
        break;
      case 'PBK':
        path = commonUtil.getAssetURL() + '/images/logos/logo-pbk.png';
        break;
      case 'GAP':
        path = commonUtil.getAssetURL() + '/images/logoGap.png';
        break;
      case 'WLM':
        path = commonUtil.getAssetURL() + '/images/logos/logo-we.png';
        break;
      case 'WS':
        path = commonUtil.getAssetURL() + '/images/logos/logo-ws.png';
        break;
      case 'TRU':
        path = commonUtil.getAssetURL() + '/images/logo-toys.png';
        break;
      default:
        break;
    }
    return path;
  }

  render() {
    this.brandLogo = this.getBrandLogoPath();
    const { printClass } = this.props;
    let settingCSS = {};
    if (typeof window !== 'undefined' && (window.location.pathname.indexOf('tableOrganizer') > -1 || window.location.pathname.indexOf('gestiondemesa') > -1)) {
      settingCSS = { width: 'auto', padding: '48px 68px 0px 0px' };
    }
    const mesa_de_regalos_logo = commonUtil.getImageMeta().mesaDeRegalosLogo;

    return (
      <div className={'printPage ' + (printClass || 'toPrint')} style={settingCSS}>
        <div className="row pdfclass">
          <div className="col-xs-6 col-sm-6 pdf-header-imgs">
            <img src={this.brandLogo} className='brand-img-logo' />
            <img className="pdf-mesalogo" src={mesa_de_regalos_logo} />
          </div>
            <div className="col-xs-6 col-sm-6 text-right mt-15">
              <div className="mt-15">{commonUtil.formatDate(this.props.printingDate, 'dd/mm/yyyy')}</div>
            </div>
        </div>
        <div id="divPrint">
          {this.props.children}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  printingDate: state.info && state.info.data && state.info.data.time,
});

export default connect(mapStateToProps, undefined)(DownloadPdfHeader);
